var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var MainThreadJob = /** @class */ (function () {
    function MainThreadJob(work) {
        this.isDone = false;
        this.args = [];
        this.workModule = work;
    }
    MainThreadJob.prototype.with = function (args) {
        this.args = args;
        return this;
    };
    MainThreadJob.prototype.execute = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var work = _this.workModule.get();
                var result = work.call.apply(work, __spreadArrays([null], _this.args));
                resolve(result);
            }
            catch (e) {
                reject(e);
            }
        }).finally(function () { return (_this.isDone = true); });
    };
    return MainThreadJob;
}());
export default MainThreadJob;
